export function Rules() {
  return (
    <div className="mx-auto flex w-full max-w-[420px] flex-col gap-4 px-5 py-6 text-sm text-ivory/85">
      <h1 className="heading-display text-3xl">Как играть</h1>
      <p className="text-xs text-ivory/55">Подкидной дурак, 2–6 игроков</p>

      <Section title="Цель">
        <p>
          Избавиться от всех карт. Кто остался с картами на руках — тот <strong>дурак</strong>.
          Остальные делят банк поровну (платформа удерживает 10% комиссии).
        </p>
      </Section>

      <Section title="Колода и козырь">
        <ul className="ml-4 list-disc space-y-1">
          <li>2–5 игроков — колода 36 карт (от 6 до туза).</li>
          <li>6 игроков — колода 52 карты (от 2 до туза).</li>
          <li>
            Старшинство: 6 &lt; 7 &lt; … &lt; 10 &lt; В &lt; Д &lt; К &lt; Т.
          </li>
          <li>
            Нижняя карта колоды — открытый <strong>козырь</strong>. Любой козырь бьёт любую
            не-козырную, козырь старший по рангу бьёт младший козырь.
          </li>
        </ul>
      </Section>

      <Section title="Раздача">
        <p>
          Каждому раздаётся по 6 карт. Первым ходит игрок с младшим козырем на руке (если
          у всех нет — случайный).
        </p>
      </Section>

      <Section title="Атака и защита">
        <ul className="ml-4 list-disc space-y-1">
          <li>
            <strong>Атакующий</strong> кладёт на стол одну карту. <strong>Защитник</strong>{' '}
            (следующий по кругу) бьёт её картой той же масти и большего ранга, либо козырем.
          </li>
          <li>
            Любой не-защитник может <strong>подкинуть</strong> карту того же ранга, что уже
            лежит на столе. Подкидывать можно пока на руке защитника есть чем отбиваться,
            но не более 6 пар атака+защита за раунд.
          </li>
          <li>
            Если защитник отбил всё — атакующий говорит «Бито», карты уходят в отбой.
          </li>
          <li>
            Если защитник не может или не хочет отбиваться — он <strong>забирает</strong> все
            карты со стола в руку и пропускает следующий ход.
          </li>
        </ul>
      </Section>

      <Section title="Добор">
        <p>
          После раунда каждый добирает из колоды до 6 карт (первым — атакующий, последним —
          защитник). Когда колода кончилась, добор не идёт; кто остался без карт — выходит из
          партии победителем.
        </p>
      </Section>

      <Section title="Таймауты">
        <ul className="ml-4 list-disc space-y-1">
          <li>На каждый ход даётся <strong>30 секунд</strong>. По таймауту защитник «забирает», атакующий «бито».</li>
          <li>
            При отключении даётся 30 секунд на reconnect; не вернулся — техническое поражение,
            банк делится между остальными.
          </li>
        </ul>
      </Section>

      <Section title="Ставки">
        <p>
          Ставка считается во внутриигровых <strong>фишках</strong> и списывается с твоего
          баланса при входе в очередь. Это не Telegram Stars — фишки это игровая валюта,
          которую можно купить за Stars, USDT, TON и т.д.
        </p>
        <p>
          Если матч не состоялся — возврат автоматический. После партии: проигравший теряет
          ставку, остальные делят банк поровну (платформа берёт 10%). Ничья — возврат каждому.
          Подробнее о фишках —{' '}
          <a href="/balance" className="text-gold underline">здесь</a>, об условиях —{' '}
          <a href="/terms" className="text-gold underline">здесь</a>.
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="heading-display text-xl text-gold">{title}</h2>
      {children}
    </section>
  );
}
